import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { MdLockOutline } from 'react-icons/md';

// What the signed-out visitor is missing on each page, keyed by path prefix.
const PAGE_LABELS = [
	['/home', 'your dashboard'],
	['/positions', 'your positions'],
	['/wallet', 'your wallet'],
	['/alert', 'your price alerts'],
	['/accounts', 'your account'],
	['/support', 'your support tickets'],
	['/profile', 'your profile'],
	['/accountinformation', 'your profile'],
	['/privacysecurity', 'your security settings'],
	['/helpsupport', 'help & support'],
	['/payment', 'your payment details']
];

const labelFor = pathname => PAGE_LABELS.find(([prefix]) => pathname.startsWith(prefix))?.[1] || 'this page';

// Layout route: renders the nested page for signed-in users, and a
// sign-in / sign-up block for everyone else. Markets stays public.
const RequireAuth = () => {
	const { pathname } = useLocation();

	if (localStorage.getItem('access_token')) {
		return <Outlet />;
	}

	return (
		<div className="flex justify-center px-4 py-16 md:py-24">
			<div className="w-full max-w-md bg-white rounded-2xl shadow-sm border border-[#e6e6e6] p-8 text-center">
				<div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-[#e6f8f1]">
					<MdLockOutline className="text-[#00ba77]" size={28} />
				</div>
				<h2 className="text-xl font-semibold text-[#111] mb-2">Sign in to view {labelFor(pathname)}</h2>
				<p className="text-[#666] mb-7">Create a free account or sign in to trade, fund your wallet and track your positions.</p>
				<div className="flex flex-col sm:flex-row gap-3">
					<button
						onClick={() => (window.location.href = '/register')}
						className="flex-1 border border-[#00ba77] rounded-lg text-[#00ba77] font-medium py-3"
					>
						Sign Up
					</button>
					<button
						onClick={() => (window.location.href = '/login')}
						className="flex-1 bg-[#00ba77] text-white rounded-lg border border-[#00ba77] font-medium py-3"
					>
						Sign In
					</button>
				</div>
				<Link to="/?technicals" className="inline-block mt-6 text-sm text-[#00ba77] font-medium hover:underline">
					Browse the markets instead
				</Link>
			</div>
		</div>
	);
};

export default RequireAuth;
